import Dashboard from "../Pages/Dashboard/Dashboard";
import ProjectList from "../Pages/Masters/ProjectList";
import ProjectProfile from "../Pages/Masters/ProjectProfile";
import ManageDocument from '../Components/ManageProject/Document'
import ManageContractorList from "../Components/ManageProject/ContractorList"
import ManageConsultantList from "../Components/ManageProject/ConsultantList"
import ManageGallery from "../Components/ManageProject/Gallery"
import ManageTask from "../Components/ManageProject/Task";
import ViewAllRequest from "../Pages/Masters/ViewAllRequest";
import ItemList from "../Pages/Masters/ItemList";
import AllProjectList from "../Pages/Dashboard/AllProjectList";
import CompletedProjects from "../Pages/Dashboard/CompletedProjects";
import PendingProjects from "../Pages/Dashboard/PendingProjects";
import PendingRequest from "../Pages/Dashboard/PendingRequest";
import InspectionRequest from "../Pages/Masters/InspectionRequest";
import ViewForm from "../Pages/Masters/ViewForm";
import ClearenceRequiredList from "../Pages/Masters/ClearenceRequiredList";
import ViewSubmittedInspectionForm from "../Pages/Masters/ViewSubmittedInspectionForm";
import ManageProjectRequestList from "../Components/ManageProject/ProjectRequest";
import ManageAssignedItems from "../Components/ManageProject/AssignedItems";
import AccountInformation from "../Pages/AccountInformation";
import ManageProjectInspection from "../Components/ManageProject/ProjectInspection";
import ProjectInspectionList from "../Components/ProjectsProfile/ProjectInspectionList";

// routes.js
const routes = [
  ////////////////////// Dashboard Routing ///////////////////////////
  { path: "/", element: <Dashboard /> },
  { path: "/AccountInformation", element: <AccountInformation /> },
  { path: "/AllProjects", element: <AllProjectList /> },
  { path: "/CompletedProjects", element: <CompletedProjects /> },
  { path: "/PendingProjects", element: <PendingProjects /> },
  { path: "/PendingRequests", element: <PendingRequest /> },

  ////////////////////// Master's Routing ///////////////////////////
  { path: "/ProjectList", element: <ProjectList /> },
  { path: "/ViewAllRequest", element: <ViewAllRequest /> },
  { path: "/InspectionRequest", element: <InspectionRequest /> },
  { path: "/ClearenceList", element: <ClearenceRequiredList /> },
  { path: "/FillForm/:inspection_id?/:project_id?/:project_request_id?/:contractor_id?", element: <ViewForm /> },
  { path: "/ClearenceList/ViewSubmittedInspectionForm/:project_inspection_id?", element: <ViewSubmittedInspectionForm /> },

  ////////////////////// Master's Products Start ///////////////////////////
  { path: "/ProjectProfile/:project_id?", element: <ProjectProfile /> },
  { path: "/Documents/:project_id?", element: <ManageDocument /> },
  { path: "/ContractorList/:project_id?", element: <ManageContractorList /> },
  { path: "/ConsultantList/:project_id?", element: <ManageConsultantList /> },
  { path: "/Gallery/:project_id", element: <ManageGallery /> },
  { path: "/Task/:project_id?", element: <ManageTask /> },
  { path: "/ProjectRequest/:project_id", element: <ManageProjectRequestList /> },
  { path: "/AssignedItems/:project_id?", element: <ManageAssignedItems /> },
  { path: "/ProjectInspection/:project_id?", element: <ManageProjectInspection /> },
  { path: "/ProjectInspectionList/:project_id?", element: <ProjectInspectionList /> },


  // Item List 
  { path: "/ItemList/:project_id", element: <ItemList /> },


];

export default routes;
